import React, {Component} from 'react';

import {
    Dimensions,
    StyleSheet,
    Image,
    ScrollView,
    FlatList,
    Linking,
    ActivityIndicator,
    TouchableOpacity,
    View, Text, Platform,

} from 'react-native';

import HMTextView from "../../../../customviews/HMTextView";
import HMButton from "../../../../customviews/HMButton";
import Colors from "../../../../tools/Colors";
import HMActionBar from "../../../../customviews/HMActionBar";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextInput from "../../../../customviews/HMTextInput";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import {typeExport} from "../../../../redux/store/type";
import PathFile from "../../../../assets/PathFile";
import {wordifyRials, wordifyRialsInTomans} from "../../../../tools/convertNumberToCharachterPrice/wordifyfa";
import * as NavigationService from "../../../../redux/NavigationService";
import HMIcon from "../../../../customviews/HMIcon";
import {KeyboardAvoidingView} from "./ListVirtualBankSatiaScreen";
import HMListSelect from "../../../../customviews/HMListSelect";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import axios from "axios";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import i18n from "../../../../I18n/i18n";


export default class IncreaseCreditSatiaScreen extends Component {


    constructor(props) {

        super(props);

        let customer = props.DataSplashSatiaScreen.user ? props.DataSplashSatiaScreen.user.customer : null;

        this.state = {

            increaseCreditAmount: null,

            paymentStatus: 0, //0 not yet -- 1 success  -- 2 failure
            indexSelectCheckBoxPay: customer && customer.banks ? customer.banks[0].Serial : null

        }

    }

    componentWillReceiveProps(props) {

    }


    componentDidMount() {

        Linking.addEventListener('url', this.handleOpenURL);

    }


    componentWillUnmount() {

        Linking.removeEventListener('url', this.handleOpenURL);

    }


    handleOpenURL = (event) => {

        this.navigate(event.url);

    }

    navigate = (url) => {

        const route = url.replace(/.*?:\/\//g, '');

        const status = route.match(/\/([^\/]+)\/?$/)[1];

        switch (status) {

            case "success": {

this.getWalletDataServer();
             //   this.props.callServiceSetWallet(this.state.increaseCreditAmount, 1)

                this.setState({paymentStatus: 1});

                break;

            }

            case "failure": {

                this.setState({paymentStatus: 2});

                break;

            }

            default: {

                this.setState({paymentStatus: 0});

                break;

            }

        }

    }

    getWalletDataServer() {
        const formData = new FormData();
        formData.append('token', this.props.token);
        axios(
            {
                url: typeExport._baseUrlSatia + "payments/getWallet",
                method: "post",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    //  "Authorization": token,
                },
                data: formData,
                timeout: typeExport._TIMEOUT,
                //   CancelToken: CancelToken.token
                // cancelToken: new CancelToken(function executor(c) {
                //
                //
                //     // An executor function receives a cancel function as a parameter
                //    // cancel = c;
                // })
            }
        ).then(response => {

            if (response.data.wallet && response.data.wallet >= 0) {
                this.props.callServiceSetWallet(response.data.wallet)

                this.setState({
                    wallet: response.data.wallet,
                    minimumPayment: response.data.minimumPayment ? response.data.minimumPayment : this.state.minimumPayment,
                })
            }

        });

    }
    renderSuccessPayment() {

        return (<View style={styles.containerHasLoading}>

            <Image style={{width: moderateScale(100), height: moderateScale(100)}}

                   source={PathFile.image.success}/>

            <HMTextView type={"bold"} style={{marginTop: moderateScale(15), fontSize: moderateScale(16)}}

                        text={"کاربر گرامی افزایش اعتبار شما با موفقیت انجام شد!"}/>

            <HMButton text={i18n.t('constant.Back')} style={{marginTop: moderateScale(15)}} textType={"bold"}

                      onPress={() => this.props.navigation.pop()}/>

        </View>);


    }


    renderFailurePayment() {

        return (<View style={styles.containerHasLoading}>

            <Image style={{width: moderateScale(100), height: moderateScale(100)}}

                   source={PathFile.image.error}/>

            <HMTextView type={"bold"} style={{marginTop: moderateScale(15), fontSize: moderateScale(16)}}

                        text={"کاربر گرامی افزایش اعتبار شما انجام نشد!"}/>

            <HMButton text={i18n.t('constant.Back')} style={{marginTop: moderateScale(15)}} textType={"bold"}

                      onPress={() => this.props.navigation.pop()}/>

        </View>);

    }


    render() {
        let {DataSplashSatiaScreen} = this.props;

        return (

            this.state.paymentStatus === 0 ?

                // this.props.showLoading ? <View style={styles.containerHasLoading}>
                //
                //         <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>
                //
                //     </View> :

                    <View style={styles.container}>


                        <HMActionBarSatia back menu props={this.props} statusBarTransparent
                                          text={"افزایش اعتبار"}
                                          headerVisibility
                                          more_menu
                                          drawer
                                          onBackPress={() => this.props.navigation.pop()}/>
                        <View style={{width: "100%"}}>
                            {
                                DataSplashSatiaScreen && DataSplashSatiaScreen.wallet && DataSplashSatiaScreen.wallet >= 0 && false&&
                                <View
                                    onPress={() => {
                                        NavigationService.navigateParams("IncreaseCreditSatiaScreen")

                                    }}
                                    style={{
                                        flexDirection: "row",

                                        //  alignSelf: 'center',
                                        // alignItems: "center",
                                        justifyContent: "center",

                                        width: '96%',
                                        alignSelf: "center",
                                        // height: moderateScale(40),
                                        marginVertical: moderateScale(4),
                                        paddingHorizontal: moderateScale(2),

                                        marginTop: moderateScale(15),

                                        // backgroundColor: Colors.white,
                                        // borderRadius: moderateScale(8),
                                        //  borderColor: Colors.colorSecondPrimary,
                                        //  borderWidth: moderateScale(1),
                                    }}
                                >
                                    <HMIcon name={"ios-wallet-outline"} style={{
                                        fontSize: moderateScale(20),
                                        color: Colors.colorSecondPrimary,
                                        marginHorizontal: moderateScale(4)
                                    }}/>

                                    <HMTextView
                                        type="bold"

                                        style={{
                                            // alignSelf: "center",
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(13),
                                            //    textAlign: 'center'

                                        }}
                                        _children
                                        styleRoot={{
                                            flexDirection: 'column',
                                            flex: 1,
                                            // justifyContent: "flex-end",
                                            flexWrap: 'wrap',
                                            //    alignItems: 'center', justifyContent: 'center'
                                        }}
                                    >
                                        کیف پول شما
                                        <HMTextView cammas
                                                    text={(DataSplashSatiaScreen.wallet / 10)}
                                                    style={{
                                                        color: Colors.green,
                                                        marginHorizontal: moderateScale(6)
                                                    }}

                                        />
                                        تومان است برای افزایش لطفا میزان اعتبار درخواستی را انتخاب یا وارد کنید
                                    </HMTextView>

                                </View>
                            }


                            {/*   <HMTextView text={" کاربر گرامی لطفا میزان اعتبار درخواستی  را انتخاب یا وارد کنید "}

                                    type={"bold"} style={{

                            textAlign: "center",

                            color: "black",

                            marginTop: moderateScale(15),

                            fontSize: moderateScale(13),

                            paddingTop: moderateScale(10)

                        }}/>*/}


                            <HMTextInput cammas keyboardType={"numeric"}

                                         style={{marginTop: moderateScale(10)}}

                                         value={this.state.increaseCreditAmount}

                                         onChangeText={(text) => this.setState({increaseCreditAmount: text})}

                                         themeColor="#555" placeholder={"مبلغ را به تومان وارد کنید"}
                                         styleRoot={{alignSelf: "center", width: '96%',}}
                            />
                            {
                                this.state.increaseCreditAmount ?
                                    <HMTextView
                                        text={wordifyRialsInTomans(this.state.increaseCreditAmount * 10)}

                                        type={"bold"}
                                        style={{

                                            //textAlign: "center",

                                            color: Colors.colorSecondPrimary,

                                            marginTop: moderateScale(4),

                                            fontSize: moderateScale(12),
                                            marginHorizontal: moderateScale(10)

                                            //  paddingTop: moderateScale(10)

                                        }}/>
                                    :
                                    null
                            }
                            <View
                                style={{
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    marginHorizontal: moderateScale(12),

                                }}>
                                <HMTextView type={"bold"} text={"نوع درگاه" + " : "} style={{
                                    color: Colors.blackLight,
                                    fontSize: moderateScale(14),
                                    marginEnd: moderateScale(10)
                                }}/>
                                <View
                                    //     style={{flex:1,justifyContent:'center'}}
                                >
                                    <HMListSelect
                                        style={{alignSelf: 'center', marginVertical: moderateScale(6),}}
                                        //data={this.props.DataSplashSatiaScreen.results.listBank}
                                        data={{
                                            list:
                                                this.props.DataSplashSatiaScreen.user && this.props.DataSplashSatiaScreen.user.customer && this.props.DataSplashSatiaScreen.user.customer.banks ? this.props.DataSplashSatiaScreen.user.customer.banks : [],
                                            //     [
                                            //     {
                                            //         id: 1,
                                            //         name: "سامان",
                                            //         image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSIPAF_qd4tBEm0qrW50NLcGUT4of2a_qlOgQT6eqzrflr0gWKR&usqp=CAU'
                                            //     },
                                            //     {
                                            //         id: 2,
                                            //         name: "آپ",
                                            //         image: 'https://s.cafebazaar.ir/1/icons/com.sibche.aspardproject.app_512x512.png'
                                            //     },
                                            //     {
                                            //         id: 3,
                                            //         name: "ملت",
                                            //         image: 'https://www.drupal.org/files/project-images/mellat.jpg'
                                            //     },
                                            //
                                            // ],

                                            indexSelect: this.state['indexSelectCheckBoxPay'],
                                            name: 'Pay',

                                        }}
                                        onPress={this.onPressSelectCheckBox
                                        }

                                    />
                                </View>
                            </View>

                            <HMButton textType={"bold"} text={"ادامه"} type={"outline"}

                                      onPress={() => this.props.callService("payments/setWallet", `?Price=${this.state.increaseCreditAmount * 10}&token=${this.props.token}&serialBank=${this.state['indexSelectCheckBoxPay']}`, typeExport.typeSetIncreaseCredit, 'POST', this.props.token)}

                                      style={{margin: moderateScale(15)}}/>

                            {/*       <HMDivider/>*/}

                            <View style={{flexDirection: "row", marginTop: moderateScale(20)}}>

                                <HMButton textType={"bold"}

                                          onPress={() => this.setState({increaseCreditAmount: "10000"})}

                                          text={"۱۰،۰۰۰ تومان"}

                                          style={{flex: 0.5}}/>

                                <HMButton textType={"bold"}

                                          onPress={() => this.setState({increaseCreditAmount: "20000"})}

                                          text={"۲۰،۰۰۰ تومان"}

                                          style={{flex: 0.5}}/>

                            </View>

                            <View style={{flexDirection: "row", marginTop: moderateScale(20)}}>

                                <HMButton textType={"bold"}

                                          onPress={() => this.setState({increaseCreditAmount: "30000"})}

                                          text={"۳۰،۰۰۰ تومان"}

                                          style={{flex: 0.5}}/>

                                <HMButton textType={"bold"}

                                          onPress={() => this.setState({increaseCreditAmount: "40000"})}

                                          text={"۴۰،۰۰۰ تومان"}

                                          style={{flex: 0.5}}/>

                            </View>

                            <View style={{flexDirection: "row", marginTop: moderateScale(20)}}>

                                <HMButton textType={"bold"}

                                          onPress={() => this.setState({increaseCreditAmount: "50000"})}

                                          text={"۵۰،۰۰۰ تومان"}

                                          style={{flex: 0.5}}/>

                                <HMButton textType={"bold"}

                                          onPress={() => this.setState({increaseCreditAmount: "100000"})}

                                          text={"۱۰۰،۰۰۰ تومان"}

                                          style={{flex: 0.5}}/>

                            </View>


                        </View>
                        {

                            this.props.NoInternetDialog ?

                                <DialogConnectionCustomize

                                    again

                                    onPress={() => {

                                        this.props.callserviceActionRefresh()

                                    }}

                                />

                                :

                                null

                        }
                        {
                            this.props.isLoading || this.props.showLoading ?
                                <DialogLoadingCustomize/>
                                : null
                        }
                    </View>


                :

                this.state.paymentStatus === 1 ? this.renderSuccessPayment() : this.renderFailurePayment()

        );

    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                //    ['indexSelectCheckBox' + name]: check ? item.id : item.id
                ['indexSelectCheckBox' + name]: item.id ? item.id : item.Serial
            },
            () => {
            })
    }

}


const styles = StyleSheet.create({

    container: {

        flex: 1,

        backgroundColor: Colors.backgroundColor

    },

    containerHasLoading: {

        flex: 1,

        justifyContent: "center",

        alignItems: "center",

        backgroundColor: Colors.backgroundColor

    },

});
